<template>
  <div
    class="_app-scrollbar"
    :style="styleContent"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'PageContent',
  props: {
    height: {
      type: [Number, String],
      default: 70
    },
    padding: {
      type: String,
      default: '0px 15px 0px 0px'
    },
    heightType: {
      type: String,
      default: 'vh'
    },
    scrollXY: {
      default: null
    }
  },
  watch: {
    scrollXY: {
      deep: true,
      handler (newVal) {
        if (newVal) {
          window.scrollTo(newVal)
        }
      }
    }
  },
  computed: {
    styleContent () {
      return {
        'overflow-y': 'auto',
        'padding': this.padding,
        'max-height': `${Number(this.height)}${this.heightType}`
      }
    }
  }
}
</script>
